import {
  ActiveFilterState,
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {IFarmInputQuote, QuotationStatus} from 'constants/interfaces';
import moment from 'moment';
import {_NumberWithSpaces} from 'constants/index';
import React from 'react';
import {Box, IconButton, Tooltip} from '@material-ui/core';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

export const quoteTableHeaders = (isAdmin: boolean): HeaderConfig[] => [
  {
    field: 'quoteNumber',
    title: 'Quote',
    isSortable: true,
    sortField: 'id',
    isSearchable: true,
    searchField: 'id',
    isRightAligned: true,
  },
  {
    field: 'formattedDate',
    title: 'Date',
    isSortable: true,
    isSearchable: true,
  },
  ...(isAdmin
    ? [
        {
          field: 'depotName',
          title: 'Depot',
          isSortable: true,
          isSearchable: true,
        },
      ]
    : []),
  {
    field: 'farmerFullName',
    title: 'Farmer',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedState',
    title: 'Status',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'numInputs',
    title: 'Items',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedTotal',
    title: 'Total (R)',
    sortField: 'total',
    isSortable: true,
    isSearchable: false,
    isRightAligned: true,
    noWrap: true,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const quoteTableRows = (
  quotes: IFarmInputQuote[],
  onSelect: (quote: IFarmInputQuote) => any,
): Row[] =>
  quotes.map((quote) => ({
    ...quote,
    depotName: quote.depot?.name || '',
    farmerFullName: quote.farmer.name + ' ' + quote.farmer.surname,
    numInputs: quote.lineItems.length || 0,
    formattedDate: moment(new Date(parseInt(quote.updateDate))).format(
      'YYYY-MM-DD',
    ),
    formattedTotal: 'R ' + _NumberWithSpaces(quote.total),
    formattedIsExpired: quote.isExpired ? 'Expired' : 'Active',
    actions: <QuoteRowIcons onSelect={() => onSelect(quote)} />,
  }));

const activeFilterGroup: FilterGroup = {
  name: 'Issued',
  filters: [
    {
      field: 'formattedIsExpired',
      value: 'Active',
      title: 'Active',
    },
    {
      field: 'formattedIsExpired',
      value: 'Expired',
      title: 'Expired',
    },
  ],
};

const stateFilterGroup: FilterGroup = {
  name: 'Status',
  filters: [
    {
      field: 'formattedState',
      value: 'Rejected',
      title: 'Rejected',
    },
    {
      field: 'formattedState',
      value: 'Pending',
      title: 'Pending',
    },
    {
      field: 'formattedState',
      value: 'In Review',
      title: 'In Review',
    },
    {
      field: 'formattedState',
      value: 'Pending Farmer Review',
      title: 'Pending Farmer Review',
    },
    {
      field: 'formattedState',
      value: 'Accepted',
      title: 'Accepted',
    },
  ],
};

export const quoteTableFilters = [activeFilterGroup, stateFilterGroup];

export const getDefaultStateFilter = (
  state: QuotationStatus,
): ActiveFilterState => {
  const filterIndex = [
    'REJECTED',
    'PENDING',
    'IN_REVIEW',
    'PENDING_FARMER_REVIEW',
    'ACCEPTED',
  ].findIndex((item) => item === state);
  return {
    filterGroupId: stateFilterGroup.name,
    filterIndex: filterIndex,
  };
};

function QuoteRowIcons(props: {onSelect: () => any}) {
  return (
    <Box display="flex" flexDirection="row">
      <Tooltip title="View quote" aria-label="View quote">
        <IconButton
          aria-label="view quote"
          size="small"
          onClick={props.onSelect}
        >
          <ChatBubbleOutlineIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
